import { CacheDBSchema } from '@alucio/core'
import { IDBPDatabase, openDB, deleteDB } from 'idb'
import * as logger from 'src/utils/logger'
import { isStorageQuotaLimitReached } from 'src/utils/storageQuota';

// [TODO-PWA] - Enums don't work in worker files for some reason
// [TODO-PWA] - Test cases for upgrading IDB
const setupCacheDB = async () => {
  const createContentManifest = (db: IDBPDatabase<CacheDBSchema>) => {
    const store = db.createObjectStore(
      'CACHE_MANIFEST',
      { keyPath: 'id' },
    );
    store.createIndex('by-status', 'status');
  }
  const createCachePayload = (db: IDBPDatabase<CacheDBSchema>) => {
    const store = db.createObjectStore(
      'CACHE_PAYLOAD',
      { keyPath: 'path' },
    );
    store.createIndex('by-path', 'path');
  }
  const createDB = async () => {
    return await openDB<CacheDBSchema>(
      'CacheDB',
      2,
      {
        upgrade(db, oldVersion, newVersion) {
          if (oldVersion !== 0 && oldVersion !== newVersion) {
            // check if exists in the object store

            const idxObjects : ['CACHE_MANIFEST', 'CACHE_PAYLOAD']  = ['CACHE_MANIFEST', 'CACHE_PAYLOAD'];

            idxObjects.forEach((idx) => {
              if (db.objectStoreNames.contains(idx)) {
                db.deleteObjectStore(idx);
              }
            });
            logger.PWALogger.info('[PWA] - Upgrading CacheDB from version ' + oldVersion + ' to ' + newVersion);
          }

          logger.PWALogger.info('Upgrading CacheDB')
          createContentManifest(db);
          createCachePayload(db);
        },
      });
  }
  const db = await createDB()
  db.close();
  const existingTables = db.objectStoreNames
  if (!existingTables.contains('CACHE_PAYLOAD') || !existingTables.contains('CACHE_MANIFEST')) {
    logger.PWALogger.warn('Found missing table')
    await deleteDB('CacheDB', {
      blocked() {
        console.warn('DB Delete attempt was blocked by another connection')
      },
    })
    logger.PWALogger.info('Recreating DB')
    await createDB()
    logger.PWALogger.info('DB Created')
  }
}

export const validateStorageSpace = async (): Promise<void> => {
  logger.PWALogger.info('Checking StorageQuota');
  const shouldCheckStorageUsage = !window.location.pathname.startsWith('/logout') &&
    !window.location.href.includes('refresh') && !window.location.href.includes('quota-exceeded');

  if (shouldCheckStorageUsage) {
    const quotaLimitReached = await isQuotaLimitReached();
    if (quotaLimitReached) {
      logger.PWALogger.warn('QuotaExceeded Error')
      window.location.href = `${window.location.origin}/quota-exceeded`;
    } else {
      logger.PWALogger.info('Quota not exceeded');
    }
  }
};

export const isQuotaLimitReached = async (gap: number = ((20 * 1024 * 1024))): Promise<boolean> => {
  logger.PWALogger.info('Checking StorageQuota');
  const isQuotaExceeded = await isStorageQuotaLimitReached({ gap });
  if (isQuotaExceeded) {
    logger.PWALogger.warn('QuotaExceeded');
  }
  return isQuotaExceeded;
}

export default setupCacheDB
